function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M11.3448 9.31377V34.1442C11.3448 49.0609 21.0488 62.2318 35.2719 66.6636C49.495 62.2318 59.199 49.0609 59.199 34.1442V9.31377L35.2719 3.21387L11.3448 9.31377Z",
  fill: "white",
  stroke: "#231F20"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M36.0876 3.42188V22.7491C36.0876 23.1538 36.0829 23.5585 36.0734 23.9631L35.835 34.1307L59.199 34.1825V9.31382L36.0876 3.42188Z",
  fill: "#FFCC00",
  stroke: "#231F20"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  d: "M35.8048 3.96582L58.9543 9.81604V34.4783H35.8048V3.96582Z",
  fill: "#FFCC00"
});

var _ref5 =
/*#__PURE__*/
React.createElement("path", {
  d: "M35.2719 3.97656V64.4183",
  stroke: "#231F20",
  strokeLinecap: "square"
});

var _ref6 =
/*#__PURE__*/
React.createElement("path", {
  d: "M59.1884 34.4565H11.3554",
  stroke: "#231F20",
  strokeLinecap: "square"
});

var SvgSecurity = function SvgSecurity(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    fill: "none",
    ref: svgRef
  }, props), React.createElement("title", null, title), _ref2, _ref3, _ref4, _ref5, _ref6);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgSecurity, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/security.d991fae9.svg";
export { ForwardRef as ReactComponent };